/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Audit_Duration_MsInputs */

const en_audit_duration_ms = /** @type {(inputs: Audit_Duration_MsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration}ms`)
};

const pt_br2_audit_duration_ms = /** @type {(inputs: Audit_Duration_MsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.duration}ms`)
};

/**
* | output |
* | --- |
* | "{duration}ms" |
*
* @param {Audit_Duration_MsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_duration_ms = /** @type {((inputs: Audit_Duration_MsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Duration_MsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_duration_ms(inputs)
	return pt_br2_audit_duration_ms(inputs)
});